export default "/images/4397756ef26bb107897927ba240dadbe.avif";